module.exports = __webpack_public_path__ + "img/edge_activites_info.ea6146b1.svg";